export default __webpack_public_path__ + "static/meningitis-a-d4a65b7e0c959ced64c8a102c7c54949.png";